<template >
  <Modal v-bind="$attrs" @cancel="$emit('cancel')" @confirm="onConfirm">
    <el-table border class="common-el-table-styles summary-el-table-styles" :height="222" :data="targetList">
      <el-table-column label="" width="55">
        <template slot-scope="{ row }">
          <el-radio v-model="targetingId" :label="row.targetingId">&ensp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="targetingId" label="ID" width="100"> </el-table-column>
      <el-table-column prop="name" label="定向包名称"> </el-table-column>
    </el-table>
  </Modal>
</template>
<script >
import Modal from './modal.vue'

export default {
  props: {
    targetList: {
      type: Array,
      default: () => []
    }
  },
  components: { Modal },
  data() {
    return {
      targetingId: ''
    }
  },
  methods: {
    onConfirm() {
      const targetItem = this.targetList.find((target) => target.targetingId === this.targetingId)
      this.$emit('confirm', targetItem)
      this.targetingId = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-list {
  max-height: 180px;
  overflow: auto;
}
</style>
